jQuery(document).ready(reportSingleInit);

function reportSingleInit(){
	
	assignIDs();
	setupNavHiglight();
	
}

function assignIDs() {
	
	var counter = 1;
	
	jQuery("#post-content .main > .wp-block-group").each(function(){
		jQuery(this).attr("id", "group-"+counter);
		counter++;
	});
	
	jQuery("#post-content nav li a").on("click", function(e){
		
		e.preventDefault();
		
		var current = jQuery(this);
		
		jQuery('html,body').animate({scrollTop: jQuery(jQuery(this).attr("href")).offset().top - 40},'fast', function(){
			jQuery("nav li.active").removeClass("active");
			current.parent().addClass("active");
		});
		
	});
	
}

function setupNavHiglight(){
	
	const options = {
		root: null,
		rootMargin: '0px 0px -20% 0px',
		threshold: 0
	};
	
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
		  const id = entry.target.getAttribute('id');
		  if (entry.intersectionRatio > 0) {
			jQuery("nav li.active").removeClass("active");
			document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.add('active');
			
		  } else {
			document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.remove('active');
			if(!jQuery("nav li.active").length) {
				
				var screenHeight = jQuery(window).height();
				var offset = jQuery(window).scrollTop();
				var current = jQuery(".wp-block-group[id='" + id +"']");
				var last = jQuery("#post-content .main > .wp-block-group").last();
				var lastOffset = last.offset().top;
				var lastHeight = last ? last.height() : 0;
				var previous = current.prev();
				var next = current.next();
				var nextTop = next.offset() ? next.offset().top : 99999999999;
				
				//console.log("Next: " + next.attr("id") + ": " + next.offset().top + " | window offset: " + offset);
				if(next.offset() && nextTop < offset) {
					//console.log("Next: " + next.attr("id") + ": " + next.offset().top + " | window offset: " + offset);
					jQuery("nav li a[href='#" + id +"']").parent().next().addClass("active");
				} else if(previous.offset() && offset < lastOffset + lastHeight) {
					//console.log("Previous: " + previous.attr("id") + ": " + previous.offset().top + " | window offset: " + offset);
					jQuery("nav li a[href='#" + id +"']").parent().prev().addClass("active");
				}
				
				
			}
		  }
		});
	  }, options);
	
	  // Track all sections that have an `id` applied
	  document.querySelectorAll('.wp-block-group[id]').forEach((section) => {
		observer.observe(section);
	  });

}
